export default function reducer() {
    return {};
}
